<div class="subscription-file-item">

  <div class="icon">
    <i class="fa fa-file-o"></i>
  </div>

  <div class="name">
    <div class="loading-placeholder" *ngIf="loadingFile$ | async">
    </div>
    {{ (file$ | async)?.fileName }}
  </div>

  <div class="size">
    <div class="loading-placeholder" *ngIf="loadingFile$ | async">
    </div>
    {{ (file$ | async)?.size | fileSize }}
  </div>


  <div class="date">
    <div class="loading-placeholder" *ngIf="loadingFile$ | async">
    </div>
    {{ (file$ | async)?.creationDateTime | cDate }}
  </div>

</div>

